import { render, staticRenderFns } from "./InspectionIssueBadge.vue?vue&type=template&id=3fd9bf2c&scoped=true"
import script from "./InspectionIssueBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionIssueBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionIssueBadge.vue?vue&type=style&index=0&id=3fd9bf2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd9bf2c",
  null
  
)

export default component.exports